class StickyAtcButton extends HTMLElement {
  constructor() {
    super()
    this.buyBox = document.querySelector('.c-product-purchase')
  }

  connectedCallback() {
    const that = this

    window.addEventListener('scroll', () => {
      if(that.buyBox.getBoundingClientRect().bottom < 0) {
        that.classList.add('visible')
        document.body.classList.add('pdp-sticky-atc-visible')
      } else {
        that.classList.remove('visible')
        document.body.classList.remove('pdp-sticky-atc-visible')
      }
    });

    this.addEventListener('click', this.scrollToBuyBox.bind(this))
  }

  scrollToBuyBox(event) {
    this.buyBox.scrollIntoView({ behavior: "smooth", block: "end" });
  }
}

if (!customElements.get('sticky-atc-button')) customElements.define('sticky-atc-button', StickyAtcButton)
